import React, { useState, useEffect, useRef } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import MenuItem from "./MenuItem";
import {itemsFilter} from "../../../redux/reducers/menuReducers";


export const MenuItemsGroupSection = ({ groupItem, menuItems, itemsFilter, addToSectionsRefs }) => {
  let menuItemsList = menuItems.filter(i => i.parentId === groupItem.menu_item_id);
  const sectionName = `section_${groupItem.menu_item_id}`;
  const currentRef = useRef(null);


  if (itemsFilter && itemsFilter.trim() !== '') {
    menuItemsList = menuItemsList.filter(i => i.item_name.toLowerCase().includes(itemsFilter.toLowerCase()));
  }

  useEffect(()=>{
    addToSectionsRefs({
      section: sectionName,
      ref: currentRef,
      menuItemId: groupItem.menu_item_id,
      menuItemName: groupItem.item_name
    });
  },[groupItem]);

  return (
    menuItemsList.length > 0 && (
    <div name={ sectionName }
         ref={ currentRef }
         className="row">
      { menuItemsList.length > 0 && (
        <h3 className="headline menu-group-name">{ groupItem.item_name }</h3>
      ) }


      <ul className="shop-items">
        {
          menuItemsList.map(
            menuItem => (
              <MenuItem menuItem={ menuItem } />
            )
          )
        }
      </ul>
    </div>
    )
  );
};


const mapStateToProps = (state) => {
  const {
    menuItems,
    itemsFilter
  } = state;

  return {
    menuItems,
    itemsFilter
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemsGroupSection);
